// Libs
import { createContext, 
    // useContext, 
    // useEffect, 
    // useState 
} from "react";

// Data
//import { AuthContext } from "./AuthContext";

// Hooks
import { useLanguageHook, 
    // useLoaderHook 
} from "../hooks";

// Enums
import {
    ENUM_LANGUAGES
} from "../enums";

//import LoaderComponent from "../../shared/components/LoaderComponent/LoaderComponent";
// Types
type TAppContextProviderProps = {
    children: React.ReactNode
}

// type TAppState = {
//     containerStatus: number
// }

// Create initial empty context
const AppContext = createContext<any | null>(null);

const langaugesDropdownOptionsArr = [
    {
        label: "Italiano",
        value: ENUM_LANGUAGES.IT
    }, {
        label: "English",
        value: ENUM_LANGUAGES.EN
    }
];

/**
 * Main app context
 * @param {*} props
 * @returns
 */
const AppContextProvider = ({ children }: TAppContextProviderProps) => {
    //const { authState } = useContext(AuthContext);
    const [appText, langForText, setLangForText] = useLanguageHook();
    //const { contatoreSpinner } = useLoaderHook();


    return (
        <>
            
                <AppContext.Provider value={{
                    appText: appText,
                    langForText: langForText,
                    setLangForText: setLangForText
                }}>
                    {children}
                </AppContext.Provider>
        </>
    );
};

export default AppContextProvider;
export { AppContext, langaugesDropdownOptionsArr };
